var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "px-16 py-8 py-lg-16",
    staticStyle: {
      "max-height": "64px !important"
    },
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticStyle: {
      "width": "72px"
    },
    attrs: {
      "cols": "auto"
    }
  }), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('head-tabs', _vm._b({
    staticClass: "my-n8",
    on: {
      "input": function (value) {
        return _vm.$emit('input', value);
      }
    }
  }, 'head-tabs', {
    value: _vm.value,
    contract: _vm.contract
  }, false))], 1), _c('v-col', {
    staticClass: "d-flex justify-end align-center",
    staticStyle: {
      "width": "72px"
    },
    attrs: {
      "cols": "auto"
    }
  }, [_vm.shows_zoom ? _c('v-btn-toggle', {
    staticClass: "my-n8",
    attrs: {
      "borderless": ""
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "small": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.decreaseZoom
    }
  }, 'v-btn', {
    disabled: _vm.disabled_decrease
  }, false), [_c('v-icon', [_vm._v("mdi-minus")])], 1), _c('v-btn', _vm._b({
    attrs: {
      "small": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.increaseZoom
    }
  }, 'v-btn', {
    disabled: _vm.disabled_increase
  }, false), [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }